module.exports = __webpack_public_path__ + "static/media/icon-todo-other.3902d65c.svg";